export const RegionType = {
  FIELD: 'field',
  ANCHOR_POINT: 'anchor point'
}

export const GetRegionType = (regionType, field, value) => {
  if (regionType) {
    return regionType
  } else {
    if (value) {
      return RegionType.ANCHOR_POINT
    } else {
      return RegionType.FIELD
    }
  }
}
